import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'

const styles = require('./styles')

export const UpdateLeadFailed: React.SFC = () => (
  <ThemeConsumer>
    {({ errorStyles }) => (
      <div className={styles.updateFailedError} style={errorStyles}>
        Oops! Something went wrong on our end, please try again.
      </div>
    )}
  </ThemeConsumer>
)
